export const formatCurrency = (amount: number | string, withDecimals = false) => {
  return Number(Number(amount).toFixed(withDecimals ? 2 : 0)).toLocaleString('en-US');
};

export const limitText = (text: string, limit: number = 27) =>
  text.length > limit ? text.slice(0, limit) + '...' : text;
